/**
 * useUuid  hook
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useMemo } from "react";
import { generateId } from "../Functions/generateId";

export function useUuid(): string {
	return useMemo(() => generateId(), []);
}
